<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Select from "@/components/c-select";
import Loading from "@/components/c-loading";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
import { service } from "../../../../../services/managements/services/service";
// import { serviceType } from "../../../../../services/managements/services/servicetype.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Service Type",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
    Select
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Service Type",
      breadCrumb: {},

      serviceTypeData: {},
      serviceData: {},
      valueServiceTypeId: 0,
      valueId: 0,
      valueName: '',
      valueNameEn: '',
      valuePrice: 0,
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     
    } else {
      this.loadingData(0);   
    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      service.getOne(id)
        .then(response => {
           this.fetchingStats = true;
          if(response.data) {
            this.serviceData = response.data;

            this.breadCrumb = {
              text: response.data.name,
              active: true,
            };
            
            this.valueId = this.serviceData.id;
            this.valueServiceTypeId = this.serviceData.service_type_id;
            this.valueName = this.serviceData.name;
            this.valueNameEn = this.serviceData.name_en;
            this.valuePrice = this.serviceData.price;
          }
          this.loadingSettings(response.setting)
        });
    },


    loadingSettings: function(setting) {

      this.serviceTypeData  = {data: setting.manageservicetypes};
      console.log(this.serviceTypeData);
     
    },


    submitSave: function() {
      
      this.tryingToSubmit = true;

      let serviceSubmitData = {
        name: this.valueName,
        name_en: this.valueNameEn,
        price: this.valuePrice,
        service_type_id: this.valueServiceTypeId,
      };

      console.log(JSON.stringify(serviceSubmitData))

      if(this.isAdd) {
        service.insert(serviceSubmitData).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            this.clearForm();
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-setting-service"
                });
              } 
            });
          }
        });
      } else {
        service.update(this.$route.params.id, serviceSubmitData).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-setting-service"
                });
              } 
            });

          }
        });
      }

    },
    clearForm: function() {
      this.valueName = '';
      this.valueNameEn = '';
      this.valuePrice = 0;
      this.valueServiceTypeId = 0;
    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('manage.service.text'),
        href: '/manage/setting/service',
      }, {
        text: this.isAdd ? $t('manage.service.new') : $t('manage.service.edit'),
        active: true
      }]" :title="this.isAdd ? $t('manage.service.new') : $t('manage.service.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('manage.service.text'),
        href: '/manage/setting/service',
      }, this.breadCrumb]" :title="this.isAdd ? $t('manage.service.new') : $t('manage.service.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-6">
        <div class="card">
          <div class="card-body">
              <div class="row">
                
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'manage.service.name'"  />
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'text'"
                    :id="'name_en'"
                    v-model="valueNameEn"
                    :require="true"
                    :label="'manage.name_en'"  />
                </div>
               
              </div>
              <div class="row">
                 <div class="col-md-6">
                  <Select 
                    :id="'service_type_id'"
                    :list="this.serviceTypeData"
                    v-model="valueServiceTypeId"
                    :label="'manage.service-type.text'"
                    :require="true"
                     /> 
                </div>
                <div class="col-md-6">
                  <Input 
                    :type="'number'"
                    :id="'price'"
                    v-model="valuePrice"
                    :require="true"
                    :label="'manage.utility.price'" />
                </div>
              </div>
              


              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>